/**
 * AutismReferredForPanel — the read-only "Condition(s) Referred For" panel shown
 * on the Adult Autism review pages (SSI Review and Observation Review).
 *
 * For the Adult Autism pathway the referred condition is always Autism Spectrum
 * Disorder (ASD), so this panel just shows a single fixed, non-editable bullet.
 * It exists as a shared component (rather than an inline block duplicated per
 * page) so the two review pages cannot drift apart, and so its typography stays
 * in lock-step with the other Autism review panels.
 *
 * TYPOGRAPHY PARITY
 * The fonts here deliberately match the smaller Autism review panels (e.g.
 * NotInReportNotesPanel): a `text-sm` bold header, optional `text-xs` italic
 * instruction, and `text-sm` bullet content — rather than the larger sizes the
 * ADHD app uses on its review pages.
 */

import React from 'react';
import { ASD_CONDITION_LABEL } from '../../constants/autismConditions';

export default function AutismReferredForPanel({
  label = ASD_CONDITION_LABEL,
  description,
  className = '',
}) {
  return (
    <div className={`bg-gray-50 rounded-2xl border border-gray-200 p-6 shadow-md text-left ${className}`}>
      <h3 className="text-sm font-bold text-gray-800 mb-0.5">Condition(s) Referred For</h3>
      {description && (
        <p className="text-xs text-gray-500 italic mb-2">{description}</p>
      )}
      <div className="mt-2 p-3 bg-gray-100 border border-gray-200 rounded-lg">
        <p className="text-sm text-gray-700 flex items-start gap-2">
          <span className="text-gray-400 mt-0.5 select-none">&bull;</span>
          <span className="font-semibold">{label}</span>
        </p>
      </div>
    </div>
  );
}
